export default __webpack_public_path__ + "84f07224741a1af63f5c67c079862821.woff";